import { FC, useState } from 'react';
import clsx from 'clsx';
import { TextField, TextFieldProps } from '../TextField';
import PasswordIcon from '../../assets/icons/password.svg?react';
import styles from './PasswordField.module.css';

interface PasswordFieldProps extends TextFieldProps {}

export const PasswordField: FC<PasswordFieldProps> = (props) => {
  const [visible, setVisible] = useState(false);

  const toggleVisibility = () => setVisible((state) => !state);

  return (
    <TextField
      {...props}
      className={clsx(styles.input, props.className)}
      type={visible ? 'text' : 'password'}
    >
      <div onClick={toggleVisibility} className={styles.clickArea}>
        <PasswordIcon
          className={clsx(styles.icon, { [styles.visible]: visible })}
        />
      </div>
    </TextField>
  );
};
